import React, { Component } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import update from 'immutability-helper';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import PatientAPIConnectors from '../../api/PatientAPIConnectors';
import WoundLocationImages from '../../constants/WoundLocationImages';
import Link from '../../components/shared/Link';
import Select from '../../components/shared/Select';

const styles = {
  image: {
    margin: 'auto',
    width: '60%',
  },
  label: {
    textAlign: 'center',
  },
  buttons: {
    float: 'none',
  },
};

class CreateWoundContainer extends Component {
  state = {
    location: '',
    injuryDate: moment(),
    type: '',
    medicalRecordId: this.props.medicalRecordId,
    isCreateSuccessful: false,
  };

  handleWoundLocationChange = (value) => {
    this.setState({ location: value });
  };

  handleWoundTypeChange = (value) => {
    this.setState({ type: value });
  };

  handleInjuryDateChange = (date) => {
    this.setState({ injuryDate: date });
  };

  createValidate = () => (
    this.state.type !== ''
    && this.state.location !== ''
  );

  create = () => {
    const {
      router,
      medicalRecordId,
      actions,
    } = this.props;
    const wound = update(this.state, {
      injuryDate: { $set: this.state.injuryDate },
    });
    delete wound.isCreateSuccessful;
    PatientAPIConnectors.createWound(wound)
      .then(() => {
        actions.createSuccessAlert(i18n.t('createSucceedMsg_detail'));
        setTimeout(() => {
          router.navigate(`/medical-records/${medicalRecordId}`, { trigger: true });
        }, 1000);
      })
      .catch((err) => {
        actions.createAlert(err);
      });
  };

  render() {
    const {
      image,
      label,
      buttons,
    } = styles;
    const { injuryDate } = this.state;

    return (
      <div className="row">
        <div className="col-md-8 col-md-offset-2">
          <div className="well">
            <form className="form-horizontal">
              <fieldset>
                <legend>
                  {i18n.t('newWound')}
                </legend>
                <div className="form-group">
                  <label
                    htmlFor="selectLocation"
                    className="col-lg-2 control-label"
                  >
                    {i18n.t('location')}
                  </label>
                  <div className="col-lg-10">
                    <Select
                      className="form-control"
                      required
                      data={this.props.metadata.data.woundLocation || []}
                      onChange={this.handleWoundLocationChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="selectType" className="col-lg-2 control-label">
                    {i18n.t('type')}
                  </label>
                  <div className="col-lg-10">
                    <Select
                      className="form-control"
                      required
                      data={this.props.metadata.data.woundType || []}
                      onChange={this.handleWoundTypeChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="selectInjuryDate"
                    className="col-lg-2 control-label"
                  >
                    {i18n.t('injuryDate')}
                  </label>
                  <div className="col-lg-10 ">
                    <DatePicker
                      value={injuryDate}
                      disabledDate={date => date && date > moment().endOf('day')}
                      onChange={this.handleInjuryDateChange}
                    />
                  </div>
                </div>
              </fieldset>
              <div className="row">
                <div className="col-xs-6 col-md-6">
                  <img
                    className="img-responsive"
                    style={image}
                    src={WoundLocationImages.FRONT}
                    alt={i18n.t('front')}
                  />
                  <p style={label}>
                    {i18n.t('front')}
                  </p>
                </div>
                <div className="col-xs-6 col-md-6">
                  <img
                    className="img-responsive"
                    style={image}
                    src={WoundLocationImages.BACK}
                    alt={i18n.t('back')}
                  />
                  <p style={label}>
                    {i18n.t('back')}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-5 center-block" style={buttons}>
                  <input
                    className="btn btn-success"
                    onClick={this.create}
                    disabled={!this.createValidate()}
                    type="button"
                    value={i18n.t('create')}
                  />
                  <Link href={`/medical-records/${this.props.medicalRecordId}`} router={this.props.router}>
                    <button className="btn btn-default">
                      {i18n.t('cancel')}
                    </button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connectActionsAndReducers(CreateWoundContainer);



// WEBPACK FOOTER //
// ./src/containers/patient/CreateWoundContainer.js